// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'
import UserIcon from 'components/atoms/UserIcon'
import Icon from 'components/atoms/Icon'

const Wrapper = styled.div`
  margin-right: 50px;

  &::after {
    display: block;
    clear: both;
    content: '';
  }
  ${mediaMax.phone`
    margin-right: 0;
  `};
`
const Container = styled.div`
  display: table;
  table-layout: fixed;
`
const StatusWrapper = styled.div`
  display: inline-block;
  padding-left: ${spacing.small_2}px;
  vertical-align: bottom;
`
const Status = styled.span`
  display: block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: right;
  line-height: 1.5;
`
const MessageWrapper = styled.div`
  display: table-cell;
  width: 290px;
  padding: ${spacing.small_2}px 0 ${spacing.small_2}px ${spacing.small_2}px;
  ${mediaMax.phone`
    width: 264px;
  `};
`
const UserIconContainer = styled.div`
  display: table-cell;
  width: 40px;
`
const ThumbnailWrapper = styled.div`
  position: relative;
  display: block;
  padding-top: 66%;
`
const Thumbnail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.url});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`
const UserIconWrapper = styled.div`
  margin-bottom: -${spacing.small_3}px;
`
const MessageContent = styled.div`
  display: inline-block;
  width: 100%;
  max-width: calc(100% - 40px);
  background-color: ${Colors.grayF};
  border-radius: 16px;
  border-bottom-left-radius: ${borderRadius}px;
  overflow: hidden;
  font-size: ${fontSize.small_3}px;
`

type PropTypes = {
  opponentImage: string,
  time: string,
  thumbnailUrl: string,
  src: string,
}

export default (props: PropTypes) => (
  <Wrapper>
    <Container>
      <UserIconContainer>
        <UserIconWrapper>
          <UserIcon src={props.opponentImage} medium />
        </UserIconWrapper>
      </UserIconContainer>
      <MessageWrapper>
        <MessageContent>
          <a href={props.thumbnailUrl} target="_blank">
            <ThumbnailWrapper>
              <Thumbnail url={props.src} />
            </ThumbnailWrapper>
          </a>
        </MessageContent>
        <StatusWrapper>
          <Status>{props.time}</Status>
        </StatusWrapper>
      </MessageWrapper>
    </Container>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/SendImageOpponent/index.jsx